
@if (dailyPoints.length > 0) {
  <app-start-point />
  
  <section class="route-timeline__points">
    @for (point of dailyPoints; track point.id; let i = $index) {
      @if (pointStatuses()[i]) {
        <app-card 
          [indexCard]="i"
          [id]="point.id"
          [type]="point.type"
          [img]="point.img"
          [title]="point.title"
          [previousPointTitle]="previousTitles[i]"
          [startDate]="point.startDate"  
          [durationMinutes]="point.duration"
          [transportList]="point.transportList"
          [status]="pointStatuses()[i]"
          [attr.data-status]="pointStatuses()[i]"
          [attr.data-scroll-index]="i"
        />
      }
    } 
  </section>
}